export const EXPORT_THEME = {
  brandOrange: 'FFF68B1F',
  brandGreen: 'FF395E14',
  brandGold: 'FFF2CE6C',
  white: 'FFFFFFFF',
  bodyText: 'FF1F2937',
  mutedText: 'FF5F6B7A',
  stripeFill: 'FFF7F2EA',
  border: 'FFE5D5C0',
  organization: 'Banco Alimentare della Daunia',
  legalName: 'Francesco Vassalli ODV',
};

const LOGO_URL = `${process.env.PUBLIC_URL || ''}/web-app-manifest-192x192.png`;

let logoBufferPromise;

export function loadExportLogoBuffer() {
  if (!logoBufferPromise) {
    logoBufferPromise = fetch(LOGO_URL)
      .then((response) => {
        if (!response.ok) throw new Error('Logo non disponibile');
        return response.arrayBuffer();
      })
      .catch(() => null);
  }
  return logoBufferPromise;
}

export async function loadExportLogoDataUrl() {
  const buffer = await loadExportLogoBuffer();
  if (!buffer) return null;

  return new Promise((resolve, reject) => {
    const blob = new Blob([buffer], { type: 'image/png' });
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export function formatExportTimestamp(date = new Date()) {
  return date.toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function sanitizeExportBasename(value, fallback = 'export') {
  const safe = (value || fallback).replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '_');
  return safe || fallback;
}
